module.exports = __webpack_public_path__ + "static/media/kozamgi_rwamiko3.b35c98f2.jpg";